import styled from 'styled-components';

import { ThemeProp } from '../../../../../../../theme/Themes';

export const TooltipContent = styled.div`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  padding: 0.375rem 0.5rem;
  background: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  max-width: 15rem;
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  position: relative;

  ::after {
    content: '';
    position: absolute;
    bottom: -0.35rem;
    left: calc(50% - 0.35rem);
    width: 0;
    height: 0;
    border-left: 0.375rem solid transparent;
    border-right: 0.375rem solid transparent;
    border-top: 0.375rem solid ${(props: ThemeProp) => props.theme.colors.primary.c500};
  }
`;
